// Section 24.12: every localStorage key lives under the `utopia:` namespace.
export const NAMESPACE = 'utopia:';

export const KEYS = {
  /** Index of the autosave ring and the start-of-run save (newest first). */
  autosaveIndex: `${NAMESPACE}autosaves`,
  autosave: (id: string): string => `${NAMESPACE}autosave:${id}`,
  /** Index of named save slots (newest first). */
  slotIndex: `${NAMESPACE}slots`,
  slot: (id: string): string => `${NAMESPACE}slot:${id}`,
  settings: `${NAMESPACE}settings`,
  /** The single M1 autosave, adopted into the ring on first read. */
  legacyAutosave: `${NAMESPACE}autosave`,
} as const;
